export const isSupplier = (currentUserOrg: string, orderSupplier: string) => {
    return currentUserOrg === orderSupplier;
};
export const isCustomer = (currentUserOrg: string, orderCustomer: string) => {
    return currentUserOrg === orderCustomer;
};
